import { Enum } from './Enum';

export class PermissionEnum extends Enum {
    static AdminPanel = 'admin-panel:';
    static AdminPanelAdmin = 'admin-panel:admin';
    static WebCalendarAndReservation = 'web:calendar-and-reservation';
    static WebCafe = 'web:cafe';
    static WebDashboard = 'web:dashboard';
}
